import actions from './actions';

const {
  LIST_CLAVE_DESCUENTO,
  LIST_CLAVE_DESCUENTO_SELECTBOX,
  CREATE_CLAVE_DESCUENTO,
  READ_CLAVE_DESCUENTO,
  UPDATE_CLAVE_DESCUENTO,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const claveDescuentoCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_CLAVE_DESCUENTO:
      return {
        ...state,
        data: data
      }
    case LIST_CLAVE_DESCUENTO_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_CLAVE_DESCUENTO:
      return {
        ...state,
        record: data
      }
    case READ_CLAVE_DESCUENTO:
      return {
        ...state,
        record: data
      }
    case UPDATE_CLAVE_DESCUENTO:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default claveDescuentoCrudReducer;
